import { __rest } from "tslib";
/**
 *  流拍车辆
 */
import React, { Component } from 'react';
import { Modal, Table, Button, notification, Form, DatePicker, Row, Col } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer, showInfo, OperateShowMore } from '@/components/index';
import { dispatch } from '@@/store';
import Authorized from '@/components/Auth/auth';
import { showCarDetail, fontEndConfig } from '@/shared/utils';
import { dealListValueShow, dealTimeAnotherLine, dealValueShow } from '@/shared/functions';
import moment from 'moment';
import { toBrokeredDeal } from './index';
import { dealTableScroll } from '@/pages/CarManage/_components/function';
const confirm = Modal.confirm;
const mapStateToProps = (rootState) => ({
    carState: rootState.carState,
});
class FlowAuctionTable extends Component {
    constructor(props) {
        super(props);
        // desc 重新发拍
        this.HandleReAuction = () => {
            const idList = this.state.checkedRows;
            if (idList.length > 0) {
                dispatch.session.createSession({
                    idList,
                    routePath: '/CarManage/CreateSession',
                });
            }
            else {
                notification.warn({
                    message: '请至少选择一辆车重新发拍',
                });
            }
        };
        // desc 选中表格checkboxs
        this.onSelectedTableItem = (selectedRowKeys, selectedRows) => {
            this.setState({
                checkedRows: selectedRowKeys,
            });
        };
        this.state = {
            clipped: [
                { dataIndex: 'carModelName' },
                { dataIndex: 'vin' },
                { dataIndex: 'license' },
                { dataIndex: 'locationName' },
                { dataIndex: 'basePriceYuan' },
                { dataIndex: 'highestOfferYuan' },
                { dataIndex: 'auctionNum' },
                { dataIndex: 'passedIn' },
            ],
            colums: [
                {
                    title: '车辆信息',
                    width: 400,
                    fixed: 'left',
                    render: (rowData, index) => {
                        const { firstImage, carModelName, goodsId, vin, license, locationName, rankLevel, rankDesc, reportType } = rowData;
                        return (<div className={'lefe_right_layout'}>
                <div className={'img_item'}>
                  <img src={firstImage} alt={carModelName}/>
                </div>
                <div>
                  <div>
                    <a onClick={() => {
                            showCarDetail(goodsId);
                        }}>
                      {carModelName}
                    </a>
                  </div>
                  <div>{`VIN码：${dealValueShow(vin)}`}</div>
                  <div>
                    {reportType === 1 &&
                            <img className={'report_268v'} src={require('@/assets/report/268v_2.png')} alt="268v"/>}
                    <div className={'tag_item'}>{license}</div>
                    <div className={'tag_item'}>{locationName}</div>
                    <div className={'tag_item'}>
                      {dealValueShow((rankLevel + rankDesc) === 'undefined' ? fontEndConfig.noValueReplace : (rankLevel + rankDesc), false, fontEndConfig.noValueReplace)}
                    </div>
                  </div>
                </div>
              </div>);
                    },
                },
                {
                    title: '卖家经销商',
                    dataIndex: 'sellerName',
                    width: 200,
                    render: (text, record, index) => text ? (<a onClick={() => {
                        showInfo('seller', record.sellerCode);
                    }}>
              {text}
            </a>) : fontEndConfig.noValueReplace,
                },
                {
                    title: '价格信息',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'basePriceYuan',
                    width: 250,
                    render(basePriceYuan) {
                        return `保留价：${basePriceYuan}`;
                    },
                },
                {
                    title: '竞价信息',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'highestOfferYuan',
                    width: 250,
                    render(highestOfferYuan) {
                        return `最高价：${highestOfferYuan}`;
                    },
                },
                {
                    title: '上拍次数',
                    dataIndex: 'auctionNum',
                    width: 100,
                },
                {
                    title: '流拍信息',
                    dataIndex: 'dealCreateTime',
                    width: 200,
                    render(dealCreateTime, record) {
                        const { passedIn } = record;
                        return (<div>
                <div>流拍次数：{passedIn}</div>
                <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                        }}>
                  <div style={{ flexShrink: 0 }}>流拍时间：</div>
                  <div>{dealCreateTime ? dealTimeAnotherLine(dealCreateTime) : fontEndConfig.noValueReplace} </div>
                </div>
              </div>);
                    },
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: 100,
                    fixed: 'right',
                    render: (text, record, index) => (<OperateShowMore>
              <Authorized allow={'psgjb-carfail-match'}>
                <a onClick={() => {
                        toBrokeredDeal(record, () => {
                            dispatch.carState.updateFailAuctionCar(0);
                            dispatch.carState.getEveryStateCarNum({});
                        });
                    }} luban-id="PSGJB-CAR-LPCL-CHCJ">
                  撮合成交
                </a>
                <span />
              </Authorized>
              <Authorized allow={'psgjb-carfail-failtrading'}>
                <a onClick={() => this.showConfirm(record)} luban-id="PSGJB-CAR-LPCL-JYSB">
                  交易失败
                </a>
              </Authorized>
              <Authorized>
                <a onClick={(event) => {
                        dispatch.router.push({
                            path: '/carManage/offerdetails',
                            query: {
                                id: record.auctionId,
                            },
                        });
                    }}>
                  出价详情
                </a>
              </Authorized>
              <Authorized>
                <a onClick={() => {
                        dispatch.router.push({
                            path: '/carManage/OfferCeneList',
                            query: {
                                id: record.auctionId,
                                gd: record.goodsId,
                            },
                        });
                    }}>
                  竞拍记录
                </a>
              </Authorized>
            </OperateShowMore>),
                },
            ],
            checkedRows: [],
        };
        this.showConfirm = this.showConfirm.bind(this);
    }
    // desc显示表格内容
    componentDidMount() {
        dispatch.carState.getEveryStateCarNum({});
        this.searchData(this.props.search);
    }
    // desc更新表格内容
    updateTable(index) {
        dispatch.carState.updateFailAuctionCar(index);
    }
    // desc 交易失败
    showConfirm(data) {
        confirm({
            title: '是否确认交易失败？',
            content: '进入交易失败的车辆将无法上拍',
            onOk() {
                dispatch.carOperate.dealFail({
                    goodsId: data.goodsId,
                    callback: () => {
                        dispatch.carState.updateFailAuctionCar(0);
                        dispatch.carState.getEveryStateCarNum({});
                    },
                });
            },
            onCancel() {
            },
        });
    }
    search() {
        const { globalSearch, privateSearch } = this.state;
        const params = Object.assign(Object.assign({}, globalSearch), privateSearch);
        dispatch.carState.SET_STATE({
            searchData: params,
        });
        dispatch.carState.updateFailAuctionCar(1);
    }
    searchData(searchData) {
        const { provinceCode, cityCode } = searchData, otherSearchData = __rest(searchData, ["provinceCode", "cityCode"]);
        this.setState({
            globalSearch: Object.assign(Object.assign({}, otherSearchData), { localProvinceCode: provinceCode, locationCode: cityCode }),
        }, () => {
            this.search();
        });
    }
    render() {
        const { pageSize, pageIndex, tableData, tableTotal, carKey, searchData } = this.props.carState;
        const { colums, checkedRows, clipped } = this.state;
        const { dealColumns, scrollX } = dealTableScroll(colums);
        return (<React.Fragment>
        <TableContainer hasExport={true} exportObj={{
            type: 'goods',
            params: Object.assign(Object.assign({}, searchData), { exportType: 'goods_fail_auction_data' }),
            fileName: '车辆管理-流拍',
            allow: 'psgjb-carfail-exporting',
        }}>
          <Row gutter={16} align={'middle'} type={'flex'} justify={'space-between'} style={{
            marginRight: '100px',
        }}>
            <div>
              <Authorized allow={'psgjb-carfail-reauction'}>
                <span style={{
            margin: '0 10px',
            color: '#666666',
        }}>
                  已选择 {checkedRows.length || 0} 项
                </span>
                <Button style={{ background: '#FF571A', color: '#fff' }} onClick={() => this.HandleReAuction()} luban-id="PSGJB-CAR-LPCL-CXFP">
                  重新发拍
                </Button>
              </Authorized>
            </div>
            <Col span={8}>
              <Form.Item className={'search_time_label_border form_date_width_100'} colon={false} label={'流拍时间'}>
                <DatePicker.RangePicker placeholder={['开始时间', '结束时间']} className={'width-100'} disabledDate={(currentDate) => {
            const now = moment();
            return currentDate > now;
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} onChange={(dates) => {
            let [startTime, endTime] = dates;
            startTime && (startTime = startTime.format('YYYY-MM-DD'));
            endTime && (endTime = endTime.format('YYYY-MM-DD'));
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { startTime,
                    endTime }),
            }, () => {
                this.search();
            });
        }}/>
              </Form.Item>
            </Col>
          </Row>
          <Table className={'draw_table_all_border draw_table_checkbox scroll_table'} columns={dealColumns} dataSource={dealListValueShow({
            gistData: clipped,
            data: tableData,
        })} scroll={{
            x: scrollX,
        }} rowKey={carKey} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: tableTotal,
            onChange: this.updateTable,
            showTotal: total => `共${total}条`,
        }} rowSelection={{
            selectedRowKeys: checkedRows,
            onChange: this.onSelectedTableItem,
        }}/>
        </TableContainer>
      </React.Fragment>);
    }
}
// @ts-ignore
export default connect(mapStateToProps, null, null, { forwardRef: true })(FlowAuctionTable);
